<template>
  <WebsiteCmsShell
    class="website-settings-page"
    :title="'Setelan Website ' + clinic_name"
    subtitle="Kelola identitas, kontak, dan kanal sosial website klinik"
    action-label="Setelan Baru"
    list-eyebrow="Daftar konfigurasi"
    list-title="Setelan tersimpan"
    list-description="Pilih setelan untuk melihat, mengedit, atau mengaktifkannya."
    @action="$router.push('/website/setting/add')"
  >
    <template #list>
      <div class="website-settings-list">
        <Table purpose="master" />
      </div>
    </template>
  </WebsiteCmsShell>
</template>

<script>
import Table from "@/component/websites/SettingTable.vue";
import Form from "@/component/websites/SettingForm.vue";
import FormEdit from "@/component/websites/SettingFormEdit.vue";
import FormDetail from "@/component/websites/SettingFormDetail.vue";
import WebsiteCmsShell from "@/component/websites/WebsiteCmsShell.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  name: "website-setting",
  data() {
    return {
      form: {
        title: "",
        address: "",
        phone: "",
        emergency: "",
        support: "",
        email: "",
        text_1: "",
        text_2: "",
        text_3: "",
        facebook_id: "",
        twitter_id: "",
        instagram_id: "",
        youtube_id: "",
        linkedin_id: "",
        status: 0,
        logo: [],
      },
    FormEditActv: false,
    FormDetailActv: false,
    clinic_name : window.configuration == null ? "Medhop" :  window.configuration.clinic_name
    };
  },
  components: {
    Table,
    Form,
    FormEdit,
    FormDetail,
    WebsiteCmsShell,
  },
  computed: {
    editorTitle() {
      if (this.FormDetailActv) return "Detail setelan";
      if (this.FormEditActv) return "Edit setelan";
      return "Tambah setelan";
    },
    editorEyebrow() {
      if (this.FormDetailActv) return "Preview configuration";
      if (this.FormEditActv) return "Update configuration";
      return "New configuration";
    },
    editorDescription() {
      if (this.FormDetailActv) return "Periksa informasi konfigurasi website yang dipilih.";
      if (this.FormEditActv) return "Perbarui informasi website lalu simpan perubahan.";
      return "Lengkapi informasi untuk membuat konfigurasi website baru.";
    },
  },
  methods: {
    resetFormOnNew(){
      // reset form on new (tambah data)
      var self = this;
      Object.keys(this.form).forEach(function (key, index) {
        if (key === "logo") {
          self.form[key] = [];
        } else {
          self.form[key] = "";
        }
      });
    },

    scrollToElement(options) {
      let el = this.$el.getElementsByClassName("website-settings-editor")[0];
      if (el) {
        el.scrollIntoView(options);
        // reset form on new (tambah data)
        this.resetFormOnNew()
      }
    },

    scrollToTop(options) {
       let el = this.$el.getElementsByClassName("website-settings-hero")[0];
      // el = el ?? this.$el.getElementsByClassName("table-setting")[0];
      if (el) {
        el.scrollIntoView(options);
        // reset form on new (tambah data)
        this.resetFormOnNew()
      }
    },

    btnAddOnClick(){
      this.scrollToElement({ behavior: 'smooth' })
      this.FormEditActv = false
      this.FormDetailActv = false
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Website", route: "" },
      { title: "Setelan", route: "" },
    ]);

    // Add Website Setting
    this.$root.$on("updateWebsiteSetting", () => {
      // reset form on new (tambah data)
      this.resetFormOnNew()
      this.scrollToTop({ behavior: 'smooth' });
    });

    // Edit Website Setting
    this.$root.$on("getWebsiteSettingById", (data) => {
      this.FormEditActv = true
      this.FormDetailActv = false
     this.scrollToElement({ behavior: 'smooth' })

      if(data.status == 0){
        data.status = false
      }else if(data.status == 1){
        data.status = true
      }

     this.form = data
     this.form['_method'] = 'put'
    });

    // Cancel Edit
    this.$root.$on("cancelWebsiteSettingUpdate", () => {
      this.FormEditActv = false
      this.scrollToTop({ behavior: 'smooth' })
      this.resetFormOnNew()
    });

    // Detail Web Setting
    this.$root.$on("getWebsiteSettingByIdDetail", (data) => {
      this.FormDetailActv = true
      this.FormEditActv = false
     this.scrollToElement({ behavior: 'smooth' })
      if(data.status == 0){
        data.status = false
      }else if(data.status == 1){
        data.status = true
      }
     this.form = data
    });

      // Close Detail
    this.$root.$on("closeWebsiteSettingDetail", () => {
      this.FormDetailActv = false
      this.scrollToTop({ behavior: 'smooth' })
      this.resetFormOnNew()
    });
    
  },
};
</script>

<style lang="scss">
.website-settings-page {
  --ws-navy: #143263;
  --ws-blue: #14608f;
  --ws-teal: #1e958f;
  --ws-border: #e4ebf3;
  --ws-muted: #6b7280;
  color: #1a2433;
  padding-bottom: 22px;
}

.website-settings-hero {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  min-height: 112px;
  margin-bottom: 16px;
  padding: 20px 22px;
  overflow: hidden;
  position: relative;
  border: 1px solid rgba(20, 96, 143, 0.16);
  border-radius: 20px;
  background: linear-gradient(135deg, rgba(20, 50, 99, 0.07), rgba(30, 149, 143, 0.1));
}

.website-settings-hero::after {
  content: "";
  position: absolute;
  right: -55px;
  bottom: -95px;
  width: 210px;
  height: 210px;
  border-radius: 50%;
  background: rgba(30, 149, 143, 0.08);
  pointer-events: none;
}

.website-settings-hero__content {
  display: flex;
  align-items: center;
  gap: 15px;
  min-width: 0;
  position: relative;
  z-index: 1;
}

.website-settings-hero__icon,
.website-settings-panel-heading__icon {
  display: inline-grid;
  place-items: center;
  flex: 0 0 auto;
  width: 44px;
  height: 44px;
  border-radius: 14px;
  color: #fff;
  background: linear-gradient(135deg, var(--ws-navy), var(--ws-blue), var(--ws-teal));
  box-shadow: 0 8px 20px rgba(20, 50, 99, 0.16);
}

.website-settings-eyebrow {
  display: block;
  margin-bottom: 3px;
  color: var(--ws-teal);
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.09em;
  text-transform: uppercase;
}

.website-settings-hero h1,
.website-settings-panel-heading h2 {
  margin: 0;
  color: #162238;
  font-weight: 750;
  letter-spacing: -0.025em;
}

.website-settings-hero h1 { font-size: clamp(1.35rem, 2vw, 1.75rem); }
.website-settings-panel-heading h2 { font-size: 1.05rem; }

.website-settings-hero p,
.website-settings-panel-heading p {
  margin: 4px 0 0;
  color: var(--ws-muted);
  line-height: 1.5;
}

.website-settings-hero p { font-size: 0.84rem; }
.website-settings-panel-heading p { font-size: 0.76rem; }

.website-settings-add {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 40px;
  padding: 0 17px;
  position: relative;
  z-index: 1;
  border: 0;
  border-radius: 12px;
  color: #fff;
  background: linear-gradient(135deg, var(--ws-navy), var(--ws-blue), var(--ws-teal));
  box-shadow: 0 9px 20px rgba(20, 96, 143, 0.2);
  font-size: 0.8rem;
  font-weight: 750;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  white-space: nowrap;
}

.website-settings-add:hover {
  color: #fff;
  transform: translateY(-1px);
  box-shadow: 0 12px 24px rgba(20, 96, 143, 0.25);
}

.website-settings-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(330px, 390px);
  gap: 16px;
  align-items: start;
}

.website-settings-list,
.website-settings-editor {
  min-width: 0;
  overflow: hidden;
  border: 1px solid var(--ws-border);
  border-radius: 20px;
  background: #fff;
  box-shadow: 0 12px 32px rgba(20, 50, 99, 0.06);
}

.website-settings-editor {
  position: sticky;
  top: 92px;
}

.website-settings-panel-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  padding: 16px 18px;
  border-bottom: 1px solid var(--ws-border);
  background: linear-gradient(180deg, #fff, #fbfcfe);
}

.website-settings-panel-heading__icon {
  width: 36px;
  height: 36px;
  border-radius: 11px;
  color: var(--ws-navy);
  background: rgba(20, 50, 99, 0.08);
  box-shadow: none;
}

.website-settings-panel-heading__icon--teal {
  color: var(--ws-teal);
  background: rgba(30, 149, 143, 0.1);
}

.website-settings-editor__body { padding: 14px; }

.website-setting-table > .d-flex {
  margin: 0 !important;
  padding: 12px 16px;
  border-bottom: 1px solid var(--ws-border);
}

.website-setting-table > .d-flex > [class*="col-"] {
  width: min(100%, 260px);
  max-width: 260px;
  flex: 0 0 260px;
  padding: 0;
}

.website-setting-table .website-setting-search {
  display: flex;
  align-items: stretch;
  width: 100%;
  height: 42px !important;
  min-height: 42px !important;
  max-height: 42px !important;
  overflow: hidden;
  border: 1px solid #d7e1ec;
  border-radius: 12px !important;
  background: #fff;
  box-shadow: 0 3px 10px rgba(20, 50, 99, 0.035);
}

.website-setting-table .website-setting-search .input-group-prepend {
  display: flex;
  height: 40px !important;
  margin: 0;
}

.website-setting-table .website-setting-search .input-group-text {
  display: grid;
  place-items: center;
  width: 44px;
  height: 40px !important;
  min-height: 40px !important;
  max-height: 40px !important;
  padding: 0 !important;
  border: 0 !important;
  border-right: 1px solid #e2e8f0 !important;
  border-radius: 0 !important;
  color: var(--ws-teal) !important;
  background: #f8fafc !important;
}

.website-setting-table .website-setting-search .form-control {
  height: 40px !important;
  min-height: 40px !important;
  max-height: 40px !important;
  padding: 0 13px !important;
  border: 0 !important;
  border-radius: 0 !important;
  background: #fff !important;
  font-size: 0.78rem;
  line-height: 40px;
  box-shadow: none !important;
}

.website-setting-table .website-setting-search:focus-within {
  border-color: rgba(30, 149, 143, 0.7);
  box-shadow: 0 0 0 3px rgba(30, 149, 143, 0.1);
}

.website-setting-table .form-control:focus { border-color: rgba(30, 149, 143, 0.65); }
.website-setting-table .table-setting { margin: 0; }
.website-setting-table .table { margin: 0; }

.website-setting-table .table thead th {
  padding: 11px 14px;
  border: 0;
  border-bottom: 1px solid var(--ws-border);
  color: #64748b;
  background: #f7f9fc;
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.055em;
  text-transform: uppercase;
}

.website-setting-table .table tbody td {
  padding: 10px 14px;
  vertical-align: middle;
  border-color: #edf1f6;
  color: #334155;
  font-size: 0.78rem;
}

.website-setting-table .table-striped tbody tr:nth-of-type(odd) { background: #fbfcfe; }
.website-setting-table .table-hover tbody tr:hover { background: rgba(30, 149, 143, 0.045); }

.website-setting-table .image-input-wrapper {
  width: 104px !important;
  height: 42px !important;
  padding: 4px;
  border: 1px solid var(--ws-border);
  border-radius: 9px;
  background: #fff;
}

.website-setting-table .image-input-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.website-setting-table .btn-circle {
  display: inline-grid !important;
  place-items: center;
  width: 31px !important;
  height: 31px !important;
  min-width: 31px;
  padding: 0 !important;
  border-radius: 9px !important;
}

.website-setting-table .btn-circle i { margin: 0 !important; padding: 0 !important; font-size: 0.73rem; }

.website-setting-form {
  margin: 0;
}

.website-setting-form > [class*="col-"] { padding: 0; }

.website-setting-form .card-body {
  margin-bottom: 10px;
  padding: 13px;
  border: 1px solid var(--ws-border);
  border-radius: 14px;
  background: #fbfcfe;
}

.website-setting-form .card-title {
  margin: 0 0 10px;
  color: var(--ws-navy);
  font-size: 0.76rem;
  font-weight: 800;
  letter-spacing: 0.035em;
  text-transform: uppercase;
}

.website-setting-form .form-group { margin-bottom: 11px; }
.website-setting-form label { margin-bottom: 5px; color: #41516a; font-size: 0.74rem; font-weight: 700; }

.website-setting-form .form-control,
.website-setting-form .custom-file-label {
  min-height: 40px;
  border-color: #dce5ef;
  border-radius: 10px !important;
  color: #334155;
  background-color: #fff;
  font-size: 0.78rem;
  box-shadow: none !important;
}

.website-setting-form textarea.form-control { min-height: 76px; resize: vertical; }
.website-setting-form .form-control:focus { border-color: rgba(30, 149, 143, 0.7); box-shadow: 0 0 0 3px rgba(30, 149, 143, 0.1) !important; }
.website-setting-form .custom-file-label { padding-top: 10px; }
.website-setting-form .custom-file-label::after { height: 38px; padding-top: 10px; border-radius: 0 9px 9px 0; background: #eef6f6; color: var(--ws-teal); }

.website-setting-form .image-input-wrapper {
  display: grid;
  place-items: center;
  width: 150px !important;
  height: 58px !important;
  margin-bottom: 9px;
  padding: 6px;
  border: 1px dashed #cbd8e6;
  border-radius: 11px;
  background: #fff;
}

.website-setting-form .image-input-wrapper img { max-width: 100%; max-height: 100%; object-fit: contain; }
.website-setting-form .custom-control-label { padding-top: 1px; }
.website-setting-form .custom-switch .custom-control-label::before { border-color: #cbd5e1; }
.website-setting-form .custom-control-input:checked ~ .custom-control-label::before { border-color: var(--ws-teal); background-color: var(--ws-teal); }

.website-setting-form .btn {
  min-height: 38px;
  padding: 0 15px;
  border-radius: 10px !important;
  font-size: 0.76rem;
  font-weight: 750;
}

.website-setting-form .btn-primary,
.website-setting-form .btn-success {
  border-color: transparent !important;
  background: linear-gradient(135deg, var(--ws-navy), var(--ws-blue), var(--ws-teal)) !important;
  box-shadow: 0 7px 16px rgba(20, 96, 143, 0.16);
}

.website-setting-form--detail .form-control:disabled,
.website-setting-form--detail .form-control[readonly] { color: #526178; background: #f3f6fa; }

@media (max-width: 991.98px) {
  .website-settings-layout { grid-template-columns: 1fr; }
  .website-settings-editor { position: static; }
}

@media (max-width: 575.98px) {
  .website-settings-page { padding-bottom: 14px; }
  .website-settings-hero { align-items: stretch; flex-direction: column; padding: 17px; border-radius: 16px; }
  .website-settings-hero__icon { width: 40px; height: 40px; border-radius: 12px; }
  .website-settings-add { width: 100%; }
  .website-settings-list, .website-settings-editor { border-radius: 16px; }
  .website-settings-panel-heading { padding: 14px; }
  .website-setting-table > .d-flex > [class*="col-"] { width: 100%; max-width: none; flex-basis: 100%; }
}
</style>
